import React, { useState, createContext, useMemo } from "react";
import UserRegister from "./components/templates/UserRegister";

export const userRegisterContext = createContext();

export default function UserRegisterPage() {
  const [mailNotification, setMailNotification] = useState(1);
  const [userClass, setUserClass] = useState(2);

  const values = useMemo(
    () => ({
      mailNotification,
      setMailNotification,
      userClass,
      setUserClass,
    }),
    [mailNotification, userClass]
  );

  return (
    <userRegisterContext.Provider value={values}>
      <UserRegister />
    </userRegisterContext.Provider>
  );
}